import React, { useEffect, useState } from "react";
import "./style2.scss";
import useFetch from "../../cache/useFetch";
import { FOOTER, FOOTER_URL, GET,FOOTER_TRANSLATION_URL, FOOTER_TRANSLATION } from "../../helper/constants";
import { useNavigate } from "react-router-dom";
import { cdnImage } from "../../helper/constants";
import FOOTER_DATA from "../../constants/data-footer";
import DownloadApp from "../DownloadApp";
import { getFooterTranslation, getPrivacyConfig } from "../../service";
import PopUp from "../Popup/Popup";
import CookiesPopup from "../CookiesPopup/CookiesPopup";
import { useLanguage } from "../../cache/context/LanguageProvider";


const Footer2 = () => {
  const navigate = useNavigate();
  const [footer, setFooterData] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [footerTranslation, setFooterTranslation] = useState({});
  const [privacyConfig, setPrivacyConfig] = useState([]);
  const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);
  const [showCookiesPopup, setShowCookiesPopup] = useState(false);
  const { languagePrefix,selectedLanguage} = useLanguage();

  const { data: data,refetch } = useFetch({
    url: FOOTER_URL.replace('languagePrefix',languagePrefix),
    method: GET,
    initialEnabled: false,
    key: FOOTER,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });

  const { data: translationData,refetch:refechFooterTranslation } = useFetch({
    url: FOOTER_TRANSLATION_URL.replace('languagePrefix',languagePrefix),
    method: GET,
    initialEnabled: false,
    key: FOOTER_TRANSLATION,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });

 useEffect(() => {
    const cachedData = sessionStorage.getItem(`${FOOTER}_${selectedLanguage}`);
    if (!cachedData) {
      refetch(true);
    } else {
      refetch(false)
    }
  }, [selectedLanguage]);

  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${FOOTER_TRANSLATION}_${selectedLanguage}`);
    if (!cachedData) {
      refechFooterTranslation(true);
    }else {
      refechFooterTranslation(false)
    }
}, [selectedLanguage]);

useEffect(() => {
    if (translationData) {
      setFooterTranslation(translationData)
    }
  }, [translationData])

  useEffect(() => {
    if (!data) {
      setFooterData(FOOTER_DATA)
    }
    else {
      if (data.downloadData) {
        setShowPopUp(true);
      }
      setFooterData(data);
      setShowPopUp(data?.downloadData);
    }
    fetchPrivacyConfig();
  }, [data])

  const handleNavigation = (link = "") => {
    let playStore = 'http://bit.ly/AirtelAp';
    let appStore = 'http://bit.ly/iOsAirtel';
    let pdfs = 'assets/pdf';
    if (link?.includes(playStore) || link?.includes(appStore)) {
      window.open(link, '_blank');
    }
    else if (link?.includes(pdfs)) {
      window.open(`${cdnImage}${link}`, '_blank');
    }
    else {
      navigate(link);
    }
  }
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  const hidePopUp = () => {
    setShowPopUp(false)
  }

  const fetchPrivacyConfig = () => {
    getPrivacyConfig().then(res => {
      let config;
      config = JSON.parse(res?.data?.packageHtml);
      const replace_url = window.location.pathname;
      let pageURL = config?.url;
      setPrivacyConfig(config);
      if (pageURL?.length && pageURL.includes(replace_url)) {
        setShowPrivacyPopup(true);
        setShowCookiesPopup(true);
        addCookiePopup()
        addPrivacyPopup()
      }
      else {
        setShowPrivacyPopup(false);
        setShowCookiesPopup(false);
      }
    })
  }
  function addPrivacyPopup() {
    if (localStorage.getItem('privacy-policy-accepted') == 'true') {
      setShowPrivacyPopup(false)
    } else {
      setShowPrivacyPopup(true)
    }
  }

  function addCookiePopup() {
    if (localStorage.getItem('cookie-accepted') == 'true') {
      setShowCookiesPopup(false)
    } else {
      setShowCookiesPopup(true)
    }
  }

  const closePrivacyPopup = () => {
    setShowPrivacyPopup(false);
    if (localStorage.getItem('privacy-policy-accepted') == 'false') {
      setShowCookiesPopup(false);
    }
  }

  const closeCookiesPopup = () => {
    setShowCookiesPopup(false);
  }

  useEffect ( ()=> {
    const replace_url = window.location.pathname;
      if(!!privacyConfig?.url?.includes(replace_url)) { 

      if (!localStorage.getItem('privacy-policy-accepted')) {
          document.getElementsByTagName("html")[0].style.overflow="hidden"
      } 
      else {
          document.getElementsByTagName("html")[0].style.overflow=""
      }  
  } 
},[showPrivacyPopup])


  return (
    <>
      {(showPrivacyPopup && privacyConfig?.privacy)&& <PopUp handleClose={closePrivacyPopup}  data={privacyConfig?.privacy}/>}
      {/* {(showCookiesPopup && privacyConfig?.cookies) && <CookiesPopup handleClose={closeCookiesPopup} data={privacyConfig?.cookies} />} */}
      {showPopUp && <DownloadApp download={footer?.downloadData} hidePopup={hidePopUp} />}
      <footer className="footer">
        <div className="container">
          <div className="back-to-top visible-xs">
            <a onClick={() => scrollToTop()} className="color-red scroll-to-top font-size-20">{footerTranslation?.backToTop} &nbsp;<i class="icon-outlined-back-to-top"></i></a>
          </div>
          <div className="row">
            {!!footer?.footer_upper?.length && footer?.footer_upper.map((item, i) => (
              <div className="col-sm-2 footer-menu" key={i}>
                <input type="checkbox" />
                <h3> {item.name}</h3>
                <ul className="listing">
                  {!!item?.child?.length && item?.child?.map((child, i) => (
                    <li key={i}>
                      <a onClick={() => child.link && handleNavigation(child.link)} >
                        {(child.name === 'Google play store' || child.name === 'App Store') ? (<img className="store-image" src={`${cdnImage}${child.imageUrl}`}></img>) : (
                          <>{child.name}</>)}</a></li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="col-sm-2 last-col" >
              <div className="back-to-top hidden-xs">
                <a onClick={() => scrollToTop()} class="color-red scroll-to-top font-size-20">{footerTranslation?.backToTop} &nbsp;<i class="icon-outlined-back-to-top"></i></a>
              </div>
              <div className="follow-us">
                <div className="social-btns">
                  {!!footer?.social_media?.length && footer?.social_media.map((el, idx) => (
                    <a href={el.link} key={idx} className={el.className} target="_blank">
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <ul className="bottom-footer">
                  {!!footer?.bottom_footer?.length && footer?.bottom_footer.map((ele, idx) => (
                    <li key={idx}>
                      {ele.name && <a href={ele.link} target="blank">{ele.name} <span className="wt-footer-links-seperator"></span></a>}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-xs-12 col-sm-4 hidden-xs">
                <ul className="text-right">
                  {!!footer?.bottom_footer_logos?.length && footer?.bottom_footer_logos.map((ele, idx) => (
                    <li key={idx}>
                      {ele.logoImg && <a href={ele.link} target="blank"> <img src={ele.logoImg} alt={ele.name} /> </a>}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12">
                <div className="copyright">
                  {!!footer?.copyRight?.length && footer?.copyRight.map((copyright, idx) => (
                    <p key={idx}>{copyright.copyText}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )

};

export default Footer2;
